module.exports = __webpack_public_path__ + "static/keyword_1-d35a041f039754c3e2ad127001a721f0.jpg";